export const useLogout = (redirectTo = '/') => {
  if (process.client) {
    localStorage.removeItem('tokens');
    localStorage.removeItem('useUser');
    localStorage.removeItem('ownerStore');
    localStorage.removeItem('parkerStore');
  }

  useTokens().reset();
  useUser().$reset();
  useCosmo().$reset();

  return navigateTo(redirectTo);
}
